'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _const = require('../const');

var _const2 = _interopRequireDefault(_const);

var _bootstrap = require('../contexts/bootstrap');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SortCaret = function SortCaret(_ref) {
  var order = _ref.order;
  var orderClass = (0, _classnames2.default)('react-bootstrap-table-sort-order', {
    dropup: order === _const2.default.SORT_ASC
  });
  return _react2.default.createElement(_bootstrap.BootstrapContext.Consumer, null, function (_ref2) {
    var bootstrap4 = _ref2.bootstrap4;
    return bootstrap4 ? _react2.default.createElement('span', {
      className: 'caret-4-' + order
    }) : _react2.default.createElement('span', {
      className: orderClass
    }, _react2.default.createElement('span', {
      className: 'caret'
    }));
  });
};

SortCaret.propTypes = {
  order: _propTypes2.default.oneOf([_const2.default.SORT_ASC, _const2.default.SORT_DESC]).isRequired
};
exports.default = SortCaret;